:host {
  --font-family: 'Montserrat', sans-serif;
  --body-size: var(--body-size-medium);
  --form-field-label-width: 200px;
  height: auto;
}

.subsection-title {
  margin-bottom: calc(var(--spacer) * 3);
  font-family: 'Montserrat Medium', 'Montserrat', sans-serif;
}

#details-section {
  margin-bottom: calc(var(--spacer) * 4);

  #details-section-title {
    margin-top: calc(var(--spacer) * 2.5);
  }

  #username-ad {
    display: none;
  }

  #ad-synchronize-button {
    padding-left: calc(var(--spacer) * 2.5);
    display: inline-block;
  }

  #import-from-active-directory {
    #import-from-active-directory-toggle {
      width: auto;
      display: inline-flex;
    }

    #import-from-active-directory-description {
      padding-top: calc(var(--spacer) * 2);
      padding-bottom: calc(var(--spacer) * 2);
      display: none;
    }
  }

  #confirm-password-description {
    max-width: 229px;
    padding-top: calc(var(--spacer));
  }
}
